"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This script returns the current active breakpoint
 */
var $ = require("jquery");
// @ts-ignore
var throttle = require("lodash/throttle");
require("../css/breakpoint-helper.scss");
var classes = {
    helper: 'h-breakpoint__helper',
};
var cachedBreakpoint;
$(window).on('resize orientationchange', function () {
    cachedBreakpoint = undefined;
});
var lastViewport;
$(window).on('resize orientationchange', throttle(function () {
    var newViewport = getCurrentBreakpoint();
    if (lastViewport !== newViewport) {
        lastViewport = newViewport;
        $(window).trigger('uxViewPortChange', [newViewport]);
    }
}, 25, { leading: true, trailing: true }));
var $meassureHelper = $("<div class=\"" + classes.helper + "\"></div>");
function meassureBreakpoint() {
    if (!document.body) {
        throw new Error('Document is not ready');
    }
    $meassureHelper.appendTo(document.body);
    return window
        .getComputedStyle($meassureHelper[0], ':before')
        .getPropertyValue('content')
        .replace(/['"]/, '')
        .replace(/['"]/, '');
}
/**
 * Register a handler to listen on breakpoint change
 * Passes the current viewport
 *
 * @param handler
 * @returns {()=>JQuery}
 */
function onBreakpointChange(handler) {
    var callback = function (event, viewport) { return handler(viewport); };
    $(window).on('uxViewPortChange', callback);
    return function () { return $(window).off('uxViewPortChange', callback); };
}
exports.onBreakpointChange = onBreakpointChange;
/**
 * Returns the current breakpoint using computed style to guarantee matching
 * the css breakpoints
 */
function getCurrentBreakpoint() {
    if (!cachedBreakpoint) {
        cachedBreakpoint = meassureBreakpoint();
    }
    return cachedBreakpoint;
}
exports.default = getCurrentBreakpoint;
function isSmall(viewport) {
    return viewport === 'small';
}
exports.isSmall = isSmall;
function isMedium(viewport) {
    return viewport === 'medium';
}
exports.isMedium = isMedium;
function isLarge(viewport) {
    return viewport === 'large';
}
exports.isLarge = isLarge;
function isExtraLarge(viewport) {
    return viewport === 'extra-large';
}
exports.isExtraLarge = isExtraLarge;
function isSmallOrMedium(viewport) {
    return isSmall(viewport) || isMedium(viewport);
}
exports.isSmallOrMedium = isSmallOrMedium;
